var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcDelete = function SvgIcDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 5a1 1 0 1 1 0 2h-1v13c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V7H3a1 1 0 1 1 0-2h5V3c0-1.103.897-2 2-2h4c1.103 0 2 .897 2 2v2h5Zm-3 15V7H6v13c0 .551.448 1 1 1h10c.552 0 1-.449 1-1ZM10 5h4V3h-4v2Zm4 5v8a1 1 0 1 0 2 0v-8a1 1 0 1 0-2 0",
    fill: "#6B6C72"
  })));
};
export default SvgIcDelete;